var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import Fuse from "fuse.js";
import { groupBy, orderBy, sortBy } from "lodash";
import { CONFIG } from "../../config/app.config";
import { startOfDay } from "../../utils/date-fns.utils";
import { formatDateWithCustomClosebyFormat } from "../../utils/date.utils";
import { getLocalizedText } from "../../utils/i18n/i18n.utils";
import { ALL_DOCUMENT_CATEGORIES, DOCUMENT_CATEGORY_LABELS, } from "./document.constants";
export var getCategoriesSortedByTranslatedLabel = function () {
    return sortBy(ALL_DOCUMENT_CATEGORIES.map(function (id) { return ({
        id: id,
        key: getDocumentCategoryName(id),
    }); }), "key").map(function (_a) {
        var id = _a.id;
        return id;
    });
};
// https://stackoverflow.com/questions/8801377/getting-the-default-file-extension-for-a-content-type-in-javascript
var MIME_TYPES_EXTENSIONS = {
    // cspell:disable
    "text/html": ["html", "htm", "shtml"],
    "text/css": ["css"],
    "text/xml": ["xml"],
    "image/gif": ["gif"],
    "image/jpeg": ["jpeg", "jpg"],
    "application/x-javascript": ["js"],
    "application/atom+xml": ["atom"],
    "application/rss+xml": ["rss"],
    "text/mathml": ["mml"],
    "text/plain": ["txt"],
    "text/vnd.sun.j2me.app-descriptor": ["jad"],
    "text/vnd.wap.wml": ["wml"],
    "text/x-component": ["htc"],
    "image/png": ["png"],
    "image/tiff": ["tif", "tiff"],
    "image/vnd.wap.wbmp": ["wbmp"],
    "image/x-icon": ["ico"],
    "image/x-jng": ["jng"],
    "image/x-ms-bmp": ["bmp"],
    "image/svg+xml": ["svg"],
    "image/webp": ["webp"],
    "application/java-archive": ["jar", "war", "ear"],
    "application/mac-binhex40": ["hqx"],
    "application/msword": ["doc"],
    "application/pdf": ["pdf"],
    "application/postscript": ["ps", "eps", "ai"],
    "application/rtf": ["rtf"],
    "application/vnd.ms-excel": ["xls"],
    "application/vnd.ms-powerpoint": ["ppt"],
    "application/vnd.wap.wmlc": ["wmlc"],
    "application/vnd.google-earth.kml+xml": ["kml"],
    "application/vnd.google-earth.kmz": ["kmz"],
    "application/x-7z-compressed": ["7z"],
    "application/x-cocoa": ["cco"],
    "application/x-java-archive-diff": ["jardiff"],
    "application/x-java-jnlp-file": ["jnlp"],
    "application/x-makeself": ["run"],
    "application/x-perl": ["pl", "pm"],
    "application/x-pilot": ["prc", "pdb"],
    "application/x-rar-compressed": ["rar"],
    "application/x-redhat-package-manager": ["rpm"],
    "application/x-sea": ["sea"],
    "application/x-shockwave-flash": ["swf"],
    "application/x-stuffit": ["sit"],
    "application/x-tcl": ["tcl", "tk"],
    "application/x-x509-ca-cert": ["der", "pem", "crt"],
    "application/x-xpinstall": ["xpi"],
    "application/xhtml+xml": ["xhtml"],
    "application/zip": ["zip"],
    "application/octet-stream": [
        "bin",
        "exe",
        "dll",
        "iso",
        "img",
        "msi",
        "msp",
        "msm",
        "deb",
        "dmg",
        "eot",
    ],
    "audio/midi": ["mid", "midi", "kar"],
    "audio/mpeg": ["mp3"],
    "audio/ogg": ["ogg"],
    "audio/x-realaudio": ["ra"],
    "video/3gpp": ["3gpp", "3gp"],
    "video/mpeg": ["mpeg", "mpg"],
    "video/quicktime": ["mov"],
    "video/x-flv": ["flv"],
    "video/x-mng": ["mng"],
    "video/x-ms-asf": ["asx", "asf"],
    "video/x-ms-wmv": ["wmv"],
    "video/x-msvideo": ["avi"],
    "video/mp4": ["m4v", "mp4"],
    // cspell:enable
};
var CONTACT_FUZZY_SEARCH_POSTFIX = ["firstname", "lastname", "company"];
var DOCUMENT_FUZZY_SEARCH_PROPERTIES = __spreadArray([
    "filename"
], CONTACT_FUZZY_SEARCH_POSTFIX.map(function (postfix) { return "members.".concat(postfix); }), true);
var MAX_EXTENSION_LENGTH = 16;
export var guessExtensionFromPathAndMime = function (path, mime) {
    var _a;
    // Get extension from path
    var possibleExtension = (_a = /\.([a-zA-Z0-9]+)$/.exec(path)) === null || _a === void 0 ? void 0 : _a[1];
    if (possibleExtension && possibleExtension.length <= MAX_EXTENSION_LENGTH) {
        return possibleExtension;
    }
    // Get extension from MIME type
    if (mime) {
        var extensionsForMime = MIME_TYPES_EXTENSIONS[mime];
        if (extensionsForMime === null || extensionsForMime === void 0 ? void 0 : extensionsForMime[0]) {
            return extensionsForMime[0];
        }
    }
    return "";
};
var startsWith = function (bytes, signature, offset) {
    if (offset === void 0) { offset = 0; }
    return signature.every(function (byte, index) { return bytes[offset + index] === byte; });
};
// ponytail: hand-rolled signatures cover the image/pdf types that break Banqup.
// If broader coverage is needed later, swap for the `file-type` lib (browser build).
export var sniffExtensionFromBytes = function (bytes) {
    if (startsWith(bytes, [0x25, 0x50, 0x44, 0x46])) {
        return "pdf"; // %PDF
    }
    if (startsWith(bytes, [0xff, 0xd8, 0xff])) {
        return "jpg";
    }
    if (startsWith(bytes, [0x89, 0x50, 0x4e, 0x47])) {
        return "png";
    }
    if (startsWith(bytes, [0x47, 0x49, 0x46, 0x38])) {
        return "gif"; // GIF8
    }
    if (startsWith(bytes, [0x52, 0x49, 0x46, 0x46]) &&
        startsWith(bytes, [0x57, 0x45, 0x42, 0x50], 8)) {
        return "webp"; // RIFF....WEBP
    }
    if (startsWith(bytes, [0x49, 0x49, 0x2a, 0x00]) ||
        startsWith(bytes, [0x4d, 0x4d, 0x00, 0x2a])) {
        return "tiff";
    }
    if (startsWith(bytes, [0x42, 0x4d])) {
        return "bmp";
    }
    return null;
};
var EQUIVALENT_EXTENSIONS = {
    jpeg: "jpg",
    tif: "tiff",
};
var normalizeExtension = function (extension) {
    var lowered = extension.toLowerCase();
    return EQUIVALENT_EXTENSIONS[lowered] || lowered;
};
export var extensionsMatch = function (a, b) {
    return normalizeExtension(a) === normalizeExtension(b);
};
var SNIFF_BYTE_COUNT = 64;
// Reads the first bytes of a picked file and blocks the upload when the real
// content type contradicts the declared extension (e.g. a JPEG renamed to .png),
// which Banqup rejects with 400. Web-only: the React Native IFile has no byte
// access, so it is skipped there.
export var assertFileExtensionMatchesContent = function (file) { return __awaiter(void 0, void 0, void 0, function () {
    var buffer, detected, declared;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (typeof file.slice !== "function") {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, file.slice(0, SNIFF_BYTE_COUNT).arrayBuffer()];
            case 1:
                buffer = _a.sent();
                detected = sniffExtensionFromBytes(new Uint8Array(buffer));
                if (!detected) {
                    return [2 /*return*/];
                }
                declared = guessExtensionFromPathAndMime(file.path, file.type);
                if (declared && !extensionsMatch(detected, declared)) {
                    throw new Error(getLocalizedText("files.error.type_mismatch", { detected: detected, declared: declared }));
                }
                return [2 /*return*/];
        }
    });
}); };
// Splits picked files into ones whose content matches their extension and ones
// that don't (with a ready-to-show error message). Use at file-selection time to
// reject mismatches before they are ever uploaded.
export var filterFilesMatchingContent = function (files) { return __awaiter(void 0, void 0, void 0, function () {
    var valid, invalid, _i, files_1, file, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                valid = [];
                invalid = [];
                _i = 0, files_1 = files;
                _a.label = 1;
            case 1:
                if (!(_i < files_1.length)) return [3 /*break*/, 6];
                file = files_1[_i];
                _a.label = 2;
            case 2:
                _a.trys.push([2, 4, , 5]);
                return [4 /*yield*/, assertFileExtensionMatchesContent(file)];
            case 3:
                _a.sent();
                valid.push(file);
                return [3 /*break*/, 5];
            case 4:
                error_1 = _a.sent();
                invalid.push({ file: file, message: error_1.message });
                return [3 /*break*/, 5];
            case 5:
                _i++;
                return [3 /*break*/, 1];
            case 6: return [2 /*return*/, { valid: valid, invalid: invalid }];
        }
    });
}); };
export var getDocumentCategoryName = function (category) {
    return getLocalizedText("document.category.".concat(DOCUMENT_CATEGORY_LABELS[category]).toLowerCase());
};
export var getDocumentsSectionListDataSource = function (documents, searchQuery) {
    if (!documents) {
        return;
    }
    var filteredDocuments = documents;
    if (searchQuery) {
        var options = {
            threshold: 0.2,
            minMatchCharLength: 2,
            keys: DOCUMENT_FUZZY_SEARCH_PROPERTIES,
        };
        var fuse = new Fuse(documents, options);
        filteredDocuments = fuse.search(searchQuery);
    }
    var groupedDocuments = groupBy(filteredDocuments, function (document) {
        return startOfDay(document.createdAt || new Date());
    });
    var sortedActivitiesKeys = Object.keys(groupedDocuments).sort(function (a, b) { return new Date(b).getTime() - new Date(a).getTime(); });
    var dataSource = sortedActivitiesKeys.map(function (date) { return ({
        title: formatDateWithCustomClosebyFormat(new Date(date)),
        data: orderBy(groupedDocuments[date], ["createdAt", "id"], ["desc"]),
    }); });
    return dataSource;
};
export var getDocumentPagedQuery = function (params) {
    var _a = params.page, page = _a === void 0 ? 1 : _a, extraFilterData = params.extraFilterData, search = params.search, customFilters = params.customFilters;
    var documentPagedQuery = {
        page: page,
        limit: CONFIG.DEFAULT_FETCH_LIMIT,
        sort: [{ field: "createdAt", method: "DESC" }],
        filter: __assign({}, extraFilterData),
        search: getSearchValue(search),
        customFilters: customFilters,
    };
    return { query: documentPagedQuery, shouldRefetch: true };
};
export var getDocumentCountQuery = function (params) {
    var extraFilterData = params.extraFilterData, search = params.search, customFilters = params.customFilters;
    var documentCountQuery = {
        filter: __assign({}, extraFilterData),
        search: getSearchValue(search),
        customFilters: customFilters,
    };
    return documentCountQuery;
};
function getSearchValue(search) {
    if (search === "") {
        return;
    }
    return search;
}
